import React from 'react';
import { Link } from 'react-router-dom';

const SignUpHeader = () => {
  return (
    <div className="text-center space-y-6 mb-8">
      {/* Company Logo */}
      <Link to="/login" className="inline-flex items-center justify-center">
        <div className="w-32 h-16 flex items-center justify-center">
          <img 
            src="/assets/images/JEWELTHREAD_Vector-1757685590897.png" 
            alt="JewelThread Logo"
            className="h-full w-auto object-contain"
            style={{ backgroundColor: 'transparent' }}
          />
        </div>
      </Link>

      {/* Sign Up Header */}
      <div className="space-y-1">
        <h2 className="text-xl font-heading text-foreground">
          Create your Account
        </h2>
        <p className="text-sm text-muted-foreground">
          Join JewelThread and manage your jewelry business
        </p>
      </div>

      {/* Sign In Link in top right */}
      <div className="absolute top-6 right-6">
        <Link 
          to="/login" 
          className="text-sm text-primary hover:text-primary/80 font-medium transition-luxury"
        >
          Sign In
        </Link>
      </div>
    </div>
  );
};

export default SignUpHeader;